import * as ReselectModule from "reselect";
import { IDemandListState } from ".";
import { IApplicationState } from "..";

export const selectDemandList: ReselectModule.Selector<
  IApplicationState,
  IDemandListState
> = (state) => state.demandList;
